import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type Props = {
  testimonial: Testimonial;
  delay?: number;
};
export function TestimonialCard({
  testimonial,
  delay = 0
}: Props) {
  return <motion.figure initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col rounded-2xl border border-grape/15 bg-white p-5 shadow-[0_12px_30px_-24px_rgba(10,10,10,0.45)]" data-id="element-260" data-mp="2p7g9druzygnj">
      <figcaption className="flex items-center gap-3" data-id="element-261" data-mp="346a9pg7d35wn">
        <img src={testimonial.img} alt={testimonial.name} width={52} height={52} loading="lazy" decoding="async" className="h-[52px] w-[52px] shrink-0 rounded-full object-cover ring-2 ring-grape/50" data-id="element-262" data-mp="386kbshs19c68" />
        <div className="min-w-0" data-id="element-263" data-mp="1dsjdby0ear6o">
          <span className="block text-sm font-bold text-plum" data-id="element-264" data-mp="1dtkqq94vvprk">{testimonial.name}</span>
          <span className="mt-0.5 flex gap-0.5 text-grape" aria-label="5 out of 5 stars" data-id="element-265" data-mp="ht2um9l9x0n3">
            {Array.from({
            length: 5
          }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" data-id="element-266" data-mp="d01e5x5f4t1e" data-mpi={k} />)}
          </span>
          <div className="mt-0.5 flex items-center gap-1.5 text-xs text-plum/55" data-id="element-267" data-mp="83ayhaxizzgi">
            <span data-id="element-268" data-mp="359d2jcmno1v">📍 {testimonial.location}</span>
            {testimonial.flag && <span className="text-sm leading-none" aria-hidden="true" data-id="element-269" data-mp="10s8cv2ym9c3z">
                {testimonial.flag}
              </span>}
          </div>
        </div>
      </figcaption>
      <blockquote className="mt-4 flex-1 border-t border-grape/10 pt-3 text-[15px] leading-relaxed text-plum/75" data-id="element-270" data-mp="qtiwjemdbzpu">
        “{testimonial.quote}”
      </blockquote>
    </motion.figure>;
}